import React from "react";
import styles from "./SplitLayout.module.scss";
import { Col, Row } from "antd";

function SplitLayout({ left, right }: { left: React.ReactNode; right: React.ReactNode }) {
  return (
    <Row>
      <Col
        span={17}
        className={styles["leftContainer"]}
      >
        {left}
      </Col>
      <Col
        span={7}
        className={styles["rightContainer"]}
      >
        {right}
      </Col>
    </Row>
  );
}

export default SplitLayout;
